<style lang="scss" scoped>
  @import "./federatedID.scss";
</style>

<script>
import { CONSTANT } from '../../../utils/constant.js'
import ConfigurationService from '../configuration.service'
import api from '../../../actions/api.actions'
import traceService from '../../shared/trace/trace-service'
import utils from '../../../utils/utils'
import toasterService from '../../../utils/toaster.js'
import messages from '../../../messages.js'

const configurationService = new ConfigurationService()

export default {

  data () {
    return {
      CONSTANT: CONSTANT,
      configurationManager: configurationService
    }
  },

  computed: {
    jwtOnOff: {
      get () {
        return this.$store.state.configuration.jwtOnOff
      },

      set (value) {
        this.$store.dispatch('updateJwtOnOff', value)
      }
    },
    jwtPayload: {
      get () {
        return this.$store.state.configuration.federatedID.jwtPayload
      },
      set (value) {
        this.$store.dispatch('updateJwtPayload', value)
      }
    }
  },
  watch: {
    jwtOnOff: {
      handler () {
        this.getJwtFlag()
      }
    }
  },
  methods: {

    /**
       * This method call the isRecognize and clear the federatedToken when jwt flag is off
       *
       * */
    getJwtFlag () {
      if (this.jwtOnOff === 'off') {
        this.$store.dispatch('updateFederatedToken', '')
        this.jwtPayload = ''
        if (!configurationService.getSrcTransactionId()) {
          this.srcTransactionId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16))
          this.$store.commit('srcTransactionId', this.srcTransactionId)
        }
      }
      // else if (this.jwtOnOff === 'on' && this.$store.state.configuration.federatedToken) {
      // let mc = mcIsRecognized(this.$store.state.lightboxstore.lightbox.srcTransactionId)
      // this.$store.commit('recognized', mc)
      // }
    },

    /**
       * This method calls the Masterpass MTT to get the JWT based on given json
       * @param jwtPayload
       * @returns {Promise<void>}
       */
    async postFederatedId (jwtPayload) {
      let startDate = new Date()
      try {
        traceService.addRequestLogs({
          methodName: CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN,
          params: jwtPayload
        })
        const response = await api.getFederatedToken(jwtPayload)
        this.$store.dispatch('updateFederatedToken', response)
        const endDate = new Date()
        const timeTakenData = utils.getTimeTakenDetail(startDate, endDate)
        traceService.addResponseLogs(CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN, JSON.stringify(response), '')
        traceService.addTimeTaken(CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN, timeTakenData, CONSTANT.SRCSDK_MASTERCARD_NTW)
        toasterService.onSuccess(messages['en-US'].successMessages.FEDERATED_TOKEN_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          const timeTakenData = utils.getTimeTakenDetailsWhenError(startDate, CONSTANT.ERROR_MSG.apiFailureMsg)
          traceService.addTimeTaken(CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN, timeTakenData, CONSTANT.SRCSDK_MASTERCARD_NTW)
          traceService.addResponseLogs(CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN, JSON.stringify(error.response.data), '')
          toasterService.onFailure(messages['en-US'].errorMessages.FEDERATED_TOKEN_ERROR)
        }
      }
    }
  }
}
</script>

<template>
  <div
    id="configuration-federatedID"
    class="set-config-height"
  >
    <div class="card mb-4">
      <h5
        id="headingJWTTesting"
        aria-controls="collapseDynamicJwtTesting"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#collapseDynamicJwtTesting"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('header.jwtTest') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>
      <div
        id="collapseDynamicJwtTesting"
        aria-labelledby="headingJWTTesting"
        class="card-body collapse show"
      >
        <div class="row">
          <div class="col-sm-12 ">
            {{ $t ('label.jwtTestingEnable') }}
          </div>
        </div>
        <div
          id="jwt-preference"
          class="row mt-3"
        >
          <div class="col-sm-12">
            <label
              v-for="(key, value) in CONSTANT.CONFIG.JWT_TESTING_ENABLE"
              :key="value"
              class="jwt-OnOff"
            >
              <input
                :id="'radio-' + key"
                v-model="jwtOnOff"
                :value="key"
                type="radio"
              >
              <div class="btn">{{ value }}</div>
            </label>
            <div class="clear" />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            {{ $t ('label.jwtPayload') }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-12">
            <textarea
              id="input-jwtPayload"
              v-model="jwtPayload"
              class="form-control"
              required
              rows="3"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            <button
              id="generate-btn"
              :class="[jwtOnOff == 'on' && jwtPayload ? 'btn-primary' : 'btn-secondary disabled']"
              :disabled="jwtPayload === ''"
              class="btn"
              data-cy="generate-button"
              type="button"
              @click="postFederatedId(jwtPayload)"
            >
              {{ $t ('label.generate') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
